// eslint-disable-next-line @typescript-eslint/ban-types
export function isAnyObject(value: unknown): value is ({}) {
  return (
    typeof value === 'object'
      && value !== null
  )
}

export function isAString(value: unknown): value is string {
  return typeof value === 'string'
}

export function isANumber(value: unknown): value is number {
  return typeof value === 'number'
}

export function isANullableString(value: unknown): value is (string | null) {
  return typeof value === 'string' || value === null
}

export function isOneOf<T>(value: unknown, ...values: T[]): value is T {
  return values.includes(value as T)
}
